// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jSUT","newExpiryDate":"styles_newExpiryDate__3Iy-N","footer":"styles_footer__1vDEa"};